export const BACKGROUND_COLORS_FOR_NOTES = ["#00E0E0", "#FF47D7", "#661AFF"];
